import React from 'react';
import { ChevronsUp, ArrowUp, Equal, ArrowDown } from 'lucide-react';

// Priority as a visual symbol, not text. Each priority has its own shape +
// color so the board stays scannable without reading labels.
//   Critical → double-up chevron, red
//   High     → single-up arrow,  orange
//   Medium   → equals bars,      amber
//   Low      → single-down arrow, slate
//
// The icon-only variant (default) is for dense surfaces like Kanban cards;
// <PriorityPill /> adds a colored chip + full label for list rows.

const MAP = {
  critical: { Icon: ChevronsUp, color: 'text-red-600',    bg: 'bg-red-50',    ring: 'ring-red-100',    label: 'Critical' },
  high:     { Icon: ArrowUp,    color: 'text-orange-500', bg: 'bg-orange-50', ring: 'ring-orange-100', label: 'High' },
  medium:   { Icon: Equal,      color: 'text-amber-500',  bg: 'bg-amber-50',  ring: 'ring-amber-100',  label: 'Medium' },
  low:      { Icon: ArrowDown,  color: 'text-slate-400',  bg: 'bg-slate-50',  ring: 'ring-slate-100',  label: 'Low' },
};

export function PriorityIcon({ priority, size = 14, className = '' }) {
  const cfg = MAP[priority];
  if (!cfg) return null;
  const { Icon, color, label } = cfg;
  return (
    <span
      title={`${label} priority`}
      aria-label={`${label} priority`}
      className={`inline-flex items-center justify-center ${className}`}
      data-testid={`priority-icon-${priority}`}
    >
      <Icon size={size} className={`${color}`} strokeWidth={2.5} />
    </span>
  );
}

export function PriorityPill({ priority, size = 12, showLabel = true }) {
  const cfg = MAP[priority];
  if (!cfg) return null;
  const { Icon, color, bg, ring, label } = cfg;
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md ring-1 ${bg} ${ring} text-[11px] font-semibold ${color}`}
      data-testid={`priority-pill-${priority}`}
    >
      <Icon size={size} strokeWidth={2.5} />
      {showLabel && <span>{label}</span>}
    </span>
  );
}
